import React from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"
import "./index.scss"

const Pagination = ({ currentPage, perPage, totalItems, onPageChange , className }) => {
  const totalPages = Math.ceil(totalItems / perPage)
  const startItem = totalItems > 0 ? (currentPage - 1) * perPage + 1 : 0
  const endItem = Math.min(currentPage * perPage, totalItems)

  // Generate page numbers to display
  const getPageNumbers = () => {
    const pages = []
    const maxVisiblePages = 7

    if (totalPages <= maxVisiblePages) {
      // Show all pages if total is less than max visible
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i)
      }
    } else {
      // Always show first page
      pages.push(1)

      if (currentPage > 4) {
        pages.push("...")
      }

      // Show pages around current page
      const start = Math.max(2, currentPage - 1)
      const end = Math.min(totalPages - 1, currentPage + 1)

      for (let i = start; i <= end; i++) {
        if (i !== 1 && i !== totalPages) {
          pages.push(i)
        }
      }

      if (currentPage < totalPages - 3) {
        pages.push("...")
      }

      // Always show last page
      if (totalPages > 1) {
        pages.push(totalPages)
      }
    }

    return pages.length > 0 ? pages : [1]
  }

  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      onPageChange(page)
    }
  }

  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1)
    }
  }

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1)
    }
  }

  return (
    <div className={`pagination-container ${className || ""}`}>
      <div className="pagination-info">
        Showing {startItem} to {endItem} of {totalItems} entries
      </div>

      <div className="pagination-controls">
        <button
          className={`pagination-arrow ${currentPage === 1 ? "pagination-arrow--disabled" : ""}`}
          onClick={handlePrevious}
          disabled={currentPage === 1}
          aria-label="Previous page"
        >
          <ChevronLeft size={16} />
        </button>

        <div className="pagination-pages">
          {getPageNumbers().map((page, index) => (
            <React.Fragment key={index}>
              {page === "..." ? (
                <span className="pagination-ellipsis">...</span>
              ) : (
                <button
                  className={`pagination-page ${page === currentPage ? "pagination-page--active" : ""}`}
                  onClick={() => handlePageClick(page)}
                >
                  {page}
                </button>
              )}
            </React.Fragment>
          ))}
        </div>

        <button
          className={`pagination-arrow ${currentPage === totalPages ? "pagination-arrow--disabled" : ""}`}
          onClick={handleNext}
          disabled={currentPage === totalPages}
          aria-label="Next page"
        >
          <ChevronRight  size={16} />
        </button>
      </div>
    </div>
  )
}

export default Pagination
